import locations from 'modules/locations/store/collections/locations'
import teams from 'modules/teams/store/collections/teams'

import { AssigneeStrategy } from './types'

export const AssigneeTypeSubOptions = {
  [AssigneeStrategy.WORKSPACE]: () =>
    locations.map((location) => ({
      value: location.attributes.id,
      label: location.attributes.name,
    })),
  [AssigneeStrategy.TEAMS]: (teamIds: string[]) =>
    teams.map((team) => ({
      value: team.attributes.id,
      label: team.attributes.name,
      selected: teamIds.includes(team.attributes.id),
    })),
  [AssigneeStrategy.TEAM_LEADS]: (teamIds: string[]) =>
    teams.map((team) => ({
      value: team.attributes.id,
      label: team.attributes.name,
      selected: teamIds.includes(team.attributes.id),
    })),
}
